import { render } from "./ModalScene.vue?vue&type=template&id=32fd7752&scoped=true"
import script from "./ModalScene.vue?vue&type=script&lang=js"
export * from "./ModalScene.vue?vue&type=script&lang=js"

import "./ModalScene.vue?vue&type=style&index=0&id=32fd7752&scoped=true&lang=css"

import exportComponent from "/home/welchome/public_html/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32fd7752"]])

export default __exports__